import React, { useEffect, useState } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "../app.local.css";
import { Menu, Dropdown, Select, Spin, Modal, Tooltip } from "antd";
import { CloudUploadOutlined, ReadOutlined } from "@ant-design/icons";

import "./style.css";
import Axios from "axios";
import config from "../../config";
import { controller } from "../../controller";
import logout from "../../assets/icons/Frame 46218.png";
import setting from "../../assets/icons/Frame 3.png";
import ScrapeJobsNotificationButton from "../ScrapeJobs/ScrapeJobsNotificationButton";
import SikkaReminderBanner from "./SikkaReminderBanner";
import { resolveTourConfig } from "../GuidedOnboarding/tourConfigs";
import { featureOn } from "../sidebarAccess";
import { useOfficeFeatures } from "../officeFeatures";

const { Option } = Select;

const mapStateToProps = (state) => {
  return { authentication: state.authentication };
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function TopBar(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [officeData, setOfficeData] = useState({});
  const [officeLogo, setOfficeLogo] = useState(localStorage.getItem("officeLogo") ? JSON.parse(localStorage.getItem("officeLogo")).logo : "");
  const [serverLogo, setServerLogo] = useState();
  const [modalOfficeId, setModalOfficeId] = useState();
  const [uploadingImage, setUploadingImage] = useState(false);
  const [modalChangeOffice, setmodalChangeOffice] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [officeID, setOfficeID] = useState(JSON.parse(localStorage.getItem("office_ids")));
  const [smilepassLogo, setSmilepassLogo] = useState(
    localStorage.getItem("smilepassLogo") ? JSON.parse(localStorage.getItem("smilepassLogo")).data : []
  );

  const getLogo = async () => {
    const response = await controller.getLogo();
    setServerLogo(response.data.logo_url);
    setSmilepassLogo(response.data.dark);
  };

  useEffect(() => {
    getLogo();
    getOfficeLogo();
    refreshOffices();

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getOfficeLogo = async () => {
    const officeIdDefualt = JSON.parse(localStorage.getItem("office_ids"));
    setModalOfficeId(officeIdDefualt[0].office_id);
    const response = await controller.officeprofile(officeIdDefualt[0].office_id);
    setOfficeLogo(response.logo);
  };

  // `office_ids` is written to localStorage at LOGIN only, so an office created or
  // granted after the user's last login never showed up in the switcher until they
  // re-authenticated. Treat the cache as warm-start data (instant render, no
  // flicker) and re-fetch the real list on mount.
  const refreshOffices = async () => {
    if (!localStorage.getItem("user")) return; // logged out — nothing to refresh
    try {
      const Config = {
        headers: {
          Authorization: "Token " + JSON.parse(localStorage.getItem("user")).key,
        },
      };
      const response = await Axios.get(config.apiGateway.URL + `/clinics/selectoffice/`, Config);
      const list = Array.isArray(response.data) ? response.data : [];
      // Never let an empty/odd response wipe out a working switcher.
      if (!list.length) return;
      localStorage.setItem("office_ids", JSON.stringify(list));
      setOfficeID(list);
      // Re-point a selection the API no longer returns (office removed, or access
      // revoked) at the first office we can actually see, so the header can't stay
      // pinned to an office that's no longer ours.
      const sel = localStorage.getItem("selectedOffice");
      // selectedOffice is the office PRIMARY KEY (`id`) — that's what
      // /clinics/get-office-profile/<pk>/ and the rest of the app expect. Do NOT
      // use the Sikka `office_id` field: it's null for un-synced offices, so
      // writing it here produces `get-office-profile/null/` → 404 → the global
      // status handler bounces every page to #/error404. Only repoint when the
      // current selection really isn't in the list, and only to a real id.
      const stillValid = list.some((o) => String(o.id) === String(sel));
      if (!stillValid && list[0] && list[0].id != null) {
        localStorage.setItem("selectedOffice", String(list[0].id));
        localStorage.setItem("selectedOfficeName", list[0].office_name);
      }
    } catch (e) {
      /* keep the cached list — a failed refresh must not break the switcher */
    }
  };

  const showModal = async () => {
    const officeIdDefualt = JSON.parse(localStorage.getItem("office_ids"));
    setModalOfficeId(officeIdDefualt[0].office_id);
    const response = await controller.officeprofile(officeIdDefualt[0].office_id);
    setOfficeData(response);
    setIsModalVisible(true);
  };

  const handleopenModalChangeOffice = () => {
    if (officeID && officeID.length > 1) setmodalChangeOffice(true);
  };
  const handleCloseModalChangeOffice = () => {
    setmodalChangeOffice(false);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const changeProfileImage = async (event) => {
    setUploadingImage(true);
    let formData = new FormData();
    formData.append("office", modalOfficeId);
    if (event) formData.append("logo", event.target.files[0]);
    // const response = await controller.changeOfficeLog(formData, modalOfficeId);

    const responseGeyOfficeprofile = await controller.officeprofile(modalOfficeId);
    setOfficeData(responseGeyOfficeprofile);
    setUploadingImage(false);
  };

  const handleSelectOfficeID = async (event) => {
    setOfficeData({});
    const response = await controller.officeprofile(event);
    setOfficeData(response);
    setModalOfficeId(event);
  };

  const handleSelectDefualtOfficeID = (event) => {
    // `event` is the office PRIMARY KEY (the Option value is `key.id`).
    // selectedOffice MUST be the pk — it's what get-office-profile/<pk>/ and
    // every /clinics/office/<int:office_id>/ endpoint expect. Storing the Sikka
    // `office_id` here (nullable / alphanumeric like "D16096") is exactly what
    // broke the header: null → get-office-profile/null/ 404, "D16096" → eval crash.
    localStorage.setItem("selectedOffice", event + "");
    var a = JSON.parse(localStorage.getItem("office_ids")) || [];
    for (var i = 0; i < a.length; i++) {
      if (String(a[i].id) === String(event)) {
        localStorage.setItem("selectedOfficeName", a[i].office_name);
      }
    }

    window.location.reload();
  };
  const path = props.location.pathname.slice(1);

  // Route-aware tour label: the config for the current page names its own tour
  // (Treatment Planning on /treatment-plans, FTC Tasks on /ftc-tasks). Off a
  // tour route the icon still offers the default guided tour.
  const tourConfig = resolveTourConfig(props.location, "");
  const tourLabel = tourConfig ? `Take the ${tourConfig.reminderLabel} tour` : "Take a guided tour";
  // Off a tour route the button would open Treatment Planning's tour; hide it when
  // that page is switched off for this office.
  const officeFeatures = useOfficeFeatures();
  const showTourButton = !!tourConfig || featureOn("treatment_planning", officeFeatures);

  // Derive the shown office name from the currently-selected id so the header
  // can never show a stale name (the separately-cached selectedOfficeName could
  // drift out of sync with selectedOffice).
  const currentOfficeName = (() => {
    try {
      const sel = localStorage.getItem("selectedOffice");
      const list = JSON.parse(localStorage.getItem("office_ids") || "[]") || [];
      const match = list.find((o) => String(o.id) === String(sel));
      if (match) return match.office_name;
      if (list.length) return list[0].office_name;
    } catch (e) {
      /* fall through */
    }
    return localStorage.getItem("selectedOfficeName") || "";
  })();

  const hideBar = ["payment"].includes(path);
  if (hideBar) {
    return <div></div>;
  }

  const hasMenu = !path.includes("completeregistration");
  const menu = hasMenu ? (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ margin: 0, marginLeft: 20 }}>
        <img src={officeLogo} alt="office-logo" style={{ height: 40 }} />
        {/* <img src={"https://api.smilepass.com/media/media/Branch/logo_1.png"} alt="office-logo" style={{ width: 100 }} /> */}
      </div>

      <div className="seperator commonui_mt10"></div>

      {props.authentication.loggedIn ? (
        <ul className="menu logged-in">
          {showTourButton && (
          <li>
              <Tooltip title={tourLabel} placement="bottom">
                <button
                  type="button"
                  data-onboarding-id="topbar-take-tour"
                  onClick={() => window.dispatchEvent(new Event("guided-onboarding-start"))}
                  aria-label={tourLabel}
                  className="topbar-icon-btn"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    verticalAlign: "middle",
                    width: 40,
                    height: 40,
                    padding: 0,
                    background: "#EEEDFA",
                    border: "none",
                    borderRadius: 8,
                    cursor: "pointer",
                    color: "#6B43B5",
                    lineHeight: 1,
                  }}
                >
                  <ReadOutlined style={{ fontSize: 20, color: "#6B43B5" }} />
                </button>
              </Tooltip>
            </li>
          )}
          <li>
            <ScrapeJobsNotificationButton />
          </li>
          <li>
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item key="3" disabled>
                    {currentOfficeName}
                  </Menu.Item>

                  <Menu.Divider />

                  <Menu.Item key="1" disabled={officeID && officeID.length > 1 ? false : true} onClick={handleopenModalChangeOffice}>
                    Select office
                  </Menu.Item>
                  <Menu.Item key="0" onClick={showModal}>
                    Office information
                  </Menu.Item>
                </Menu>
              }
              onOpenChange={() => console.log("2")}
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                <img
                  src={setting}
                  alt=""
                  style={
                    windowDimensions
                      ? windowDimensions.width > "700"
                        ? { fontSize: "20px", color: "#7A08FA" }
                        : windowDimensions.width > "450"
                        ? { fontSize: "15px", color: "#7A08FA" }
                        : { fontSize: "10px", color: "#7A08FA" }
                      : { fontSize: "20px", color: "#7A08FA" }
                  }
                />
              </a>
            </Dropdown>
          </li>

          <li>
            <NavLink
              to="/"
              onClick={async () => {
                const Config = {
                  headers: {
                    Authorization: localStorage.getItem("user") ? "Token " + JSON.parse(localStorage.getItem("user")).key : "",
                  },
                };

                const response = await Axios.get(config.apiGateway.URL + `/dj-rest-auth/logout/`, Config);
                localStorage.clear();
                localStorage.removeItem("office_ids");
                localStorage.removeItem("selectedOffice");
                window.location.href = "/";
                return response;
              }}
            >
              <img
                src={logout}
                alt=""
                style={
                  windowDimensions
                    ? windowDimensions.width > "700"
                      ? { fontSize: "20px", color: "#7A08FA" }
                      : windowDimensions.width > "450"
                      ? { fontSize: "15px", color: "#7A08FA" }
                      : { fontSize: "10px", color: "#7A08FA" }
                    : { fontSize: "20px", color: "#7A08FA" }
                }
              />
            </NavLink>
          </li>
        </ul>
      ) : (
        <ul className="menu">
          <li>
            <NavLink to="/login">Login</NavLink>
          </li>
        </ul>
      )}
      <Modal title="Select Office" open={modalChangeOffice} footer={null} onCancel={handleCloseModalChangeOffice}>
        <div className="seperator commonui_mt10">
          {officeID ? (
            officeID.length > 1 ? (
              <>
                <p className="text-muted text-center">Select an item from the list below</p>

                <Select
                  className="commonui_w100"
                  showSearch
                  // Value is the office PRIMARY KEY (`id`). NEVER eval() it — the
                  // stored value can be non-numeric (a Sikka office_id like
                  // "D16096"), which made eval throw "D16096 is not defined" and
                  // took down the whole page. Parse defensively instead.
                  defaultValue={Number(localStorage.getItem("selectedOffice")) || (officeID[0] && officeID[0].id) || undefined}
                  optionFilterProp="children"
                  onSelect={(event) => handleSelectDefualtOfficeID(event)}
                >
                  {officeID.map((key) => (
                    <Option key={key.id} value={key.id}>
                      {key.office_name}
                    </Option>
                  ))}
                </Select>
              </>
            ) : (
              <> Office ID: {officeID ? officeID[0].office_id : ""}</>
            )
          ) : (
            <p>Office ID: {officeID ? officeID[0].office_id : ""}</p>
          )}
        </div>
      </Modal>
      <Modal footer={null} title="Office Information" open={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        Office :{" "}
        <Select
          className="commonui_w100"
          showSearch
          defaultValue={officeID[0].office_id}
          optionFilterProp="children"
          onSelect={(event) => handleSelectOfficeID(event)}
        >
          {officeID.map((key) => (
            <Option key={key.office_id} value={key.office_id}>
              {key.office_name}
            </Option>
          ))}
        </Select>
        <hr />
        <div>
          <div className="commonui_mb0">
            <div className="commonui_uploadcontainer">
              {!uploadingImage ? (
                officeData && officeData.logo ? (
                  <div className="commonui_tac">
                    <label>Click on the logo image and upload the new logo image</label>
                    <br />

                    <label for="fileUpload" class="custom-file-upload">
                      <img alt="logo" className="large-logo commonui_img" src={officeData.logo} />
                    </label>
                    <input
                      className="commonui_dn"
                      type="file"
                      id="fileUpload"
                      title="profile_photo"
                      required={true}
                      onChange={(e) => changeProfileImage(e)}
                      accept="image/png, image/jpeg"
                    />
                    <br />
                    <span className="commonui_fs12">(recommendation size = 150*50px)</span>
                    <br />
                  </div>
                ) : (
                  <div className="commonui_tac">
                    <label for="fileUpload" className="formLabel commonui_upload">
                      <div className="commonui_mr8">
                        <CloudUploadOutlined style={{ fontSize: "25px" }} />
                      </div>
                      <div>Click here to uploading new Logo</div>
                      <div className="upload-peyment-pdf commonui_mb5"></div>
                    </label>
                    <input
                      className="commonui_dn"
                      type="file"
                      id="fileUpload"
                      title="profile_photo"
                      required={true}
                      onChange={(e) => changeProfileImage(e)}
                      accept="image/png, image/jpeg"
                    />
                    <br />
                    <span className="commonui_fs12">(recommendation size = 150*50px)</span>
                    <br />
                  </div>
                )
              ) : (
                <div className="commonui_spin">
                  <Spin />
                </div>
              )}
            </div>
          </div>
          <hr />
          <div className="commonui_df">
            <p className="commonui_w50">
              Office ID : <b>{officeData && officeData.office_id ? officeData.office_id : "-"}</b>
            </p>
            <p>
              Website : <b>{officeData && officeData.domain ? officeData.domain : "-"}</b>
            </p>
          </div>
          <div className="commonui_df">
            <p className="commonui_w50">
              PMS : <b>{officeData && officeData.practice_management_system ? officeData.practice_management_system : "-"}</b>
            </p>
            <p>
              Address : <b>{officeData && officeData.address ? officeData.address : "-"}</b>
            </p>
          </div>
        </div>
      </Modal>
    </div>
  ) : null;
  return (
    <>
      <div className="top-bar">{menu}</div>
      {hasMenu ? <SikkaReminderBanner /> : null}
    </>
  );
}

const connected_TopBar = connect(mapStateToProps)(TopBar);
export default withRouter(connected_TopBar);
